import { lazy } from 'react';
import { retry } from '../../../../config/utils';

const AccountWithDrawals = lazy(() => retry(()=> import(/* webpackChunkName: "PartnerUploadLoan" */ "./index")));

export default AccountWithDrawals;